import React from 'react'
import { connect } from 'react-redux'
import { jt, t } from 'ttag'
import { Modal, Nav, NavItem, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { Link } from 'react-router-dom'

import occupations from '@h2/assets/svg/icons/occupations.svg'
import all from '@h2/assets/svg/icons/allOpportunities.svg'
import education from '@h2/assets/svg/icons/education.svg'
import certification from '@h2/assets/svg/icons/certification.svg'
import jobs from '@h2/assets/svg/icons/jobs.svg'
import companies from '@h2/assets/svg/icons/companies.svg'
import like from '@h2/assets/svg/icons/thumbsUpActive.svg'
import likeInactive from '@h2/assets/svg/icons/thumbsUpInactive.svg'
import dislike from '@h2/assets/svg/icons/thumbsDownActive.svg'
import disllikeInactive from '@h2/assets/svg/icons/thumbsDownInactive.svg'
import compatibility0 from '@h2/assets/svg/icons/compatibility0.svg'
import compatibility1 from '@h2/assets/svg/icons/compatibility1.svg'
import compatibility2 from '@h2/assets/svg/icons/compatibility2.svg'
import compatibility3 from '@h2/assets/svg/icons/compatibility3.svg'
import compatibility4 from '@h2/assets/svg/icons/compatibility4.svg'
import compatibility5 from '@h2/assets/svg/icons/compatibility5.svg'

import {
  createPlan,
  flagOccupation,
  loadOccupation as loadFullOccupation,
  logOccupationVideoView,
  rateOccupation,
  removeForComparison,
  retrieveComparisonRegions,
  selectComparisonRegion,
  selectForComparison,
  selectLocalTab,
  toggleOccupationModal
} from '../../actions/occupationProfile'
import { generateClassName } from '../../actions'
import ComparisonFooter from '../../components/ComparisonFooter'
import LoadingIndicator from '../../components/LoadingIndicator'
import * as h2Api from '../../h2Api'
import { openSigninDialog } from '../../actions/signinOrRegisterDialog'
import ComparisonRegionSelector from '../../components/ComparisonRegionSelector'
import PopupJournal from '../../components/journal/PopupJournal'
import Share from '../../components/social/Share'
import LmiBox from '../../components/occupations/LmiBox'
import MobileLmi from '../../components/occupations/MobileLmi'
import withRecharts from '../../components/withRecharts'
import H2VideoPlayer from '../../components/H2VideoPlayer'
import { useInitDispatch, useTitleChange } from '../../util/hooks'
import { RecommendationCard } from '../../../../ui/features/dashboard/explorer/components/recommendations/recommendationCard'

class ExpandableList extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpened: false
    }
  }

  formatter(t) {
    return <li key={t}>{t}</li>
  }

  render() {
    const items = this.props.items || []
    const num = this.props.numWhenClosed || 5
    let topItems,
      remainingItems = null

    if (items.length > num) {
      topItems = items.slice(0, num)
      remainingItems = items.slice(num, items.length)
    } else {
      topItems = items
    }

    const formatFn = this.props.formatter || this.formatter

    return (
      <div>
        <ul>{topItems.map(t => formatFn(t))}</ul>
        {remainingItems && (
          <ul
            style={{
              transition: 'all .3s ease-in-out',
              maxHeight: this.state.isOpened ? '700px' : 0,
              overflow: 'hidden'
            }}>
            {remainingItems.map(t => formatFn(t))}
          </ul>
        )}
        {remainingItems && (
          <a
            href="javascript:void(0)"
            style={{ display: 'block' }}
            className={`text-right section-expander btn-h2more ${
              this.state.isOpened ? 'open-chev' : 'closed-chev'
            }`}
            onClick={() =>
              this.setState({
                ...this.state,
                isOpened: !this.state.isOpened
              })}>
            <span>{this.state.isOpened ? t`view top ${num}` : t`view all`}</span>
          </a>
        )}
      </div>
    )
  }
}

const LocalOpportunityTypes = ({ types, primaryCluster }) => {
  const icons = typeId => {
    switch (typeId) {
      case 'remote-learning':
        return '/images/headed2/new/localopportunities/WBL-RemoteLearning-Stacked.svg'
      case 'onsite-training':
        return '/images/headed2/new/localopportunities/WBL-OnSiteTraining-Stacked.svg'
      case 'advisory':
        return '/images/headed2/new/localopportunities/WBL-Advisory-Stacked.svg'
      case 'community-engagement':
        return '/images/headed2/new/localopportunities/WBL-CommunityEngagement-Stacked.svg'
      default:
        return '/images/headed2/new/localopportunities/WBL-OnSiteTraining-Stacked.svg'
    }
  }

  return (
    <div className="section">
      <h3>
        <span>{t`Get Experience`}</span>
      </h3>
      {types?.map(tp => (
        <div className="wbl-types-matched" key={tp.url}>
          <Link
            to={`${tp.url}${primaryCluster ? `?selectedCluster=${primaryCluster}` : ''}`}
            className={tp.cssClassName}>
            <div className="text-center">{tp.name}</div>
            <div
              className="overlay-container"
              style={{
                backgroundImage: `url(${icons(tp.cssClassName)})`,
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'bottom',
                minHeight: '125px',
                backgroundColor: '#fff'
              }}>
              {tp.description && (
                <div className="hover-only">
                  <p dangerouslySetInnerHTML={{ __html: tp.description }}></p>
                </div>
              )}
            </div>
          </Link>
        </div>
      ))}
    </div>
  )
}
const LocalOpportunitySection = ({
  profile,
  selectedLocalTab,
  onSelectLocalTab,
  logJobOrderView,
  localOpportunitiesLoading
}) => {
  const localOpps = profile.localOpportunities || []
  const generateList = () => {
    //Loading, return loading sequence
    if (localOpportunitiesLoading) {
      return (
        <div className="row" style={{ minHeight: '300px' }}>
          <LoadingIndicator
            unContained={true}
            small={true}
            newSiteLook={dynamicValues.newSiteLook}
          />
        </div>
      )
    }

    //No results
    if (localOpps.length === 0) {
      return (
        <div style={{ minHeight: '300px' }}>
          <div className="no-results alert alert-warning">{t`No opportunities found`}</div>
        </div>
      )
    }

    return localOpps.map((l, idx) => {
      const addProps = l.hasOwnProperty('logString')
        ? {
            onClick: e => {
              e.preventDefault()
              logJobOrderView(profile, l)
            }
          }
        : {}

      return (
        <li
          key={l.id}
          className={`result-type-icon ${l.resultType} ${
            idx % 2 === 0 ? 'even' : 'odd'
          }`}>
          <Link to={l.url} {...addProps}>
            {l.title}
          </Link>
        </li>
      )
    })
  }

  return (
    <div className="section">
      <h3>
        <span>{t`Your Opportunities`}</span>
      </h3>
      <div className="localactions">
        <a
          className={`actionitem ${selectedLocalTab === 0 ? 'selected' : 'all'}`}
          href="javascript:void(0)"
          onClick={() => onSelectLocalTab(profile.onetSoc, 0)}>
          <img src={all} alt="" />
          {t`All`}
        </a>
        <a
          className={`actionitem ${selectedLocalTab === 1 ? 'selected' : 'all'}`}
          href="javascript:void(0)"
          onClick={() => onSelectLocalTab(profile.onetSoc, 1)}>
          <img src={education} alt="" />
          {t`Education & Training`}
        </a>
        <a
          className={`actionitem ${selectedLocalTab === 2 ? 'selected' : 'all'}`}
          href="javascript:void(0)"
          onClick={() => onSelectLocalTab(profile.onetSoc, 2)}>
          <img src={certification} alt="" />
          {t`Certifications`}
        </a>
        <a
          className={`actionitem ${selectedLocalTab === 4 ? 'selected' : 'all'}`}
          href="javascript:void(0)"
          onClick={() => onSelectLocalTab(profile.onetSoc, 4)}>
          <img src={jobs} alt="" />
          {t`Jobs`}
        </a>
        <a
          className={`actionitem ${selectedLocalTab === 3 ? 'selected' : 'all'}`}
          href="javascript:void(0)"
          onClick={() => onSelectLocalTab(profile.onetSoc, 3)}>
          <img src={companies} alt="" />
          {t`Companies`}
        </a>
      </div>
      <ul className="localopportunities">
        {generateList()}
        <div className="row">
          <div className="col-xs-12">
            {selectedLocalTab === 4 && (
              <a
                href={`/jobs/search?onetSoc=${profile.onetSoc}`}
                className="btn-h2more pull-right">
                {t`View All`}
              </a>
            )}
            {selectedLocalTab === 1 && (
              <a
                href={`/education/list?onetSoc=${profile.onetSoc}&types=majors`}
                className="btn-h2more pull-right">
                {t`View All`}
              </a>
            )}
            {selectedLocalTab === 2 && (
              <a
                href={`/education/list?onetSoc=${profile.onetSoc}&types=certifications`}
                className="btn-h2more pull-right">
                {t`View All`}
              </a>
            )}
          </div>
        </div>
      </ul>
    </div>
  )
}

class MediaSlideshow extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      selectedImage: this.sortedMedia()[0]
    }
    this.pictureTypes = ['PICTURE', 'AWSPICTURE']
  }

  firstPic() {
    const newImagesPrefix = 'videos/'
    //console.log(this.props.media, this.pictureTypes)
    const o = this.props.media
      .filter(f => this.pictureTypes.includes(f.mediaType))
      .sort((a, b) => {
        const firstNew = a.fileName.indexOf(newImagesPrefix) === 0
        const secondNew = b.fileName.indexOf(newImagesPrefix) === 0
        const isEqual = firstNew === secondNew

        if (isEqual) {
          return b.fileName.localeCompare(a.fileName)
        }

        if (firstNew) {
          return -1
        }

        return 1
      })

    //console.log(o)
    return o.length > 0 ? (o[0] || {}).url : null
  }

  sortedMedia = () => {
    return this.props.media.sort((a, b) => {
      if (a.mediaType === 'VIMEO' && b.mediaType !== 'VIMEO') {
        return -1
      }

      if (b.mediaType === 'VIMEO' && a.mediaType !== 'VIMEO') {
        return 1
      }

      return 0
    })
  }

  render() {
    return (
      <div id="mediaslideshow">
        <div className="main-img-wrap">
          <div className="main-img shown">
            {(() => {
              if (this.pictureTypes.includes(this.state.selectedImage.mediaType)) {
                return (
                  <img
                    src={this.state.selectedImage.url}
                    className="img-responsive"
                    alt="Media image of workers"
                  />
                )
              }

              if (this.state.selectedImage.mediaType === 'VIMEO') {
                return (
                  <H2VideoPlayer
                    allowSeek={true}
                    id={`vplayer--${this.state.selectedImage.url}`}
                    poster={this.firstPic()}
                    onComplete={() =>
                      this.props.dispatch(
                        logOccupationVideoView(
                          this.props.onetSoc,
                          this.state.selectedImage.fileName
                        )
                      )}>
                    <source type="video/mp4" src={this.state.selectedImage.url} />
                    {this.state.selectedImage.captionUrl && (
                      <track
                        default
                        kind="subtitles"
                        srcLang="en"
                        label="English"
                        src={this.state.selectedImage.captionUrl}
                      />
                    )}
                  </H2VideoPlayer>
                )
              }
            })()}
          </div>
        </div>
        <div className="thumb">
          <ul className="slide-thumbs container">
            {this.sortedMedia().map((p, idx) => {
              return (
                <li
                  className={`col-xs-2 ${
                    this.state.selectedImage === p ? 'active' : ''
                  } ${p.mediaType}`}
                  onClick={() => {
                    console.log(p)
                    this.setState({
                      ...this.state,
                      selectedImage: p
                    })
                  }}>
                  <img
                    src={
                      this.pictureTypes.includes(p.mediaType) ? p.url : this.firstPic()
                    }
                    alt={t`Stock photo of people doing this occupation`}
                    data-slide={`p${idx}`}
                    className="slide-img"
                  />
                </li>
              )
            })}
          </ul>
        </div>
      </div>
    )
  }
}

class SimilarOccupations extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedTab: 1
    }
    this.handleSelect.bind(this)
  }

  handleSelect(myThis) {
    return selectedKey => {
      myThis.setState({
        ...myThis.state,
        selectedTab: selectedKey
      })
    }
  }

  render() {
    const selectedOccupations = this.props.selectedOccupations
    const occupationMeta = this.props.occupationMeta
    const jobZoneValues = this.props.jobZoneValues

    return (
      <div className="section">
        <h3>
          <span>{t`Similar Occupations`}</span>
        </h3>

        {this.props.showMilitary && (
          <Nav
            bsStyle="pills"
            activeKey={this.state.selectedTab}
            onSelect={this.handleSelect(this)}>
            <NavItem eventKey={1}>{t`In the Workforce`}</NavItem>
            <NavItem eventKey={2}>{t`In the Military`}</NavItem>
          </Nav>
        )}

        {this.state.selectedTab === 1 && (
          <table className="table tbl">
            <thead>
              <tr>
                <th>
                  <OverlayTrigger
                    trigger={['hover', 'focus', 'click']}
                    placement="top"
                    overlay={(
                      <Tooltip id="comparison-instruction-description" placement="bottom">
                        {t`Select up to four boxes below to see a side-by-side comparison of the items`}
                      </Tooltip>
                    )}>
                    <i
                      className="fal fa-eye"
                      aria-hidden="true"
                      title={t`Select up to four boxes below to see a side-by-side comparison of the items`}>
                    </i>
                  </OverlayTrigger>

                  <span className="sr-only">{t`Comparison`}</span>
                </th>
                <th>{t`Occupation`}</th>
                <th>{t`Job Zone`}</th>
              </tr>
            </thead>
            <tbody>
              {this.props.relatedOnet?.map((m, i) => (
                <tr key={m.onetSoc} className={i % 2 === 0 ? 'even' : 'odd'}>
                  <td>
                    <label>
                      <span className="sr-only">{t`Select box to add to comparison`}</span>
                      <input
                        id={`check-${m.onetSoc}`}
                        type="checkbox"
                        {...(selectedOccupations.indexOf(m.onetSoc) >= 0
                          ? { checked: true }
                          : {})}
                        onChange={s => {
                          if (s.target.checked) {
                            s.target.checked =
                              !!this.props.onSelectOccupationForComparison(
                                this.props.currentOccupation,
                                m.onetSoc
                              )
                          } else {
                            return this.props.onRemoveOccupationForComparison(m.onetSoc)
                          }
                        }}
                      />
                    </label>
                  </td>
                  <td>
                    <Link to={m.url}>{m.title}</Link>
                    {occupationMeta.inBudget[m.onetSoc] && (
                      <OverlayTrigger
                        trigger={['hover', 'focus', 'click']}
                        placement="top"
                        overlay={(
                          <Tooltip id="budget-req" placement="bottom">
                            {t`This occupation would satisfy the salary requirements from your budget.`}
                          </Tooltip>
                        )}>
                        <span
                          className="badge listing-badge budget defined"
                          title={t`This occupation would satisfy the salary requirements from your budget.`}>
                          <span>budget</span>
                        </span>
                      </OverlayTrigger>
                    )}
                    {(occupationMeta.flags[m.onetSoc] || []).map(f => (
                      <OverlayTrigger
                        trigger={['hover', 'focus', 'click']}
                        placement="top"
                        overlay={(
                          <Tooltip id="flag-desc" placement="bottom">
                            {f.description}
                          </Tooltip>
                        )}>
                        <span
                          className={`badge listing-badge ${f.styleClass} defined`}
                          title={f.description}>
                          <span>{f.name}</span>
                        </span>
                      </OverlayTrigger>
                    ))}
                  </td>
                  <td>
                    <div>
                      <OverlayTrigger
                        trigger={['hover', 'focus', 'click']}
                        placement="top"
                        overlay={(
                          <Tooltip id="jobzone-desc" placement="right">
                            <div>
                              <b>{(jobZoneValues[m.jobZone] || {}).name}</b>
                              <br />
                              {(jobZoneValues[m.jobZone] || {}).description}
                            </div>
                          </Tooltip>
                        )}>
                        <div className="job-zone">{m.jobZone}</div>
                      </OverlayTrigger>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        {this.state.selectedTab === 2 && (
          <table className="table tbl">
            <thead>
              <tr>
                <th>{t`Occupation`}</th>
                <th>{t`Category`}</th>
                <th>{t`Branch`}</th>
              </tr>
            </thead>
            <tbody>
              {this.props.relatedMilitary?.map((m, i) => (
                <tr key={m.id} className={i % 2 === 0 ? 'even' : 'odd'}>
                  <td>
                    <Link to={m.url}>{m.title}</Link>
                    {(occupationMeta.flags[m.id] || []).map(f => (
                      <OverlayTrigger
                        trigger={['hover', 'focus', 'click']}
                        placement="top"
                        overlay={(
                          <Tooltip id="military-desc" placement="bottom">
                            {f.description}
                          </Tooltip>
                        )}>
                        <span
                          className={`badge listing-badge ${f.styleClass} defined`}
                          title={f.description}>
                          <span>{f.name}</span>
                        </span>
                      </OverlayTrigger>
                    ))}
                  </td>
                  <td>{m.personnelCategory.name}</td>
                  <td>{m.branchOfService.name}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    )
  }
}

const OccupationProfile = ({
  bodyModal,
  selectedProfile,
  selectedModal,
  profileCache,
  rateOccupation,
  selectedOccupations,
  onSelectOccupationForComparison,
  onRemoveOccupationForComparison,
  openModal,
  openRegionsModal,
  onFlagOccupation,
  onSelectLocalTab,
  selectedLocalTab,
  closeModal,
  onSelectRegion,
  jobZoneValues,
  logJobOrderView,
  onCreatePlan,
  profileRequest,
  localOpportunitiesLoading,
  recharts,
  dispatch,
  match
}) => {
  useTitleChange(null)

  useInitDispatch(loadFullOccupation(match?.params.occId), [match?.params.occId])

  const profile = selectedProfile || {}

  console.log(profile === null, !!profile, profile)

  if (!h2Api.receivedResponse(profileRequest)) {
    return <LoadingIndicator newSiteLook={dynamicValues.newSiteLook} />
  }

  if (!h2Api.isSuccess(profileRequest)) {
    console.log(profileRequest)

    return (
      <div className="container">
        <h2>{t`We're sorry but we can't find the occupation profile you are looking for.`}</h2>
      </div>
    )
  }

  const { Cell, Pie, PieChart, ResponsiveContainer } = recharts

  //console.log(profile, profileCache, selectedProfile)

  const aboutSection = () => {
    return (
      <div className="section">
        <h3>
          <span>{t`About the Job`}</span>
        </h3>
        <p>{profile.description}</p>
      </div>
    )
  }
  const whatTheyDoSection = () => {
    return (
      <div className="section">
        <h3>
          <span>{t`What They Do`}</span>
        </h3>
        <ExpandableList items={profile.tasks} numWhenClosed={5} />
      </div>
    )
  }
  const industryBreakdown = () => {
    const cd = profile?.industries
      ?.map(i => {
        return {
          name: i.name,
          naics: i.naics,
          value: i.percentOfWorkforce
        }
      })
      .sort((a, b) => b.value - a.value)
    //console.log(cd)
    const baseEmployment =
      (profile?.outlook?.baseEmployment &&
        profile.outlook.baseEmployment.toLocaleString()) ||
      'n/a'

    return (
      <div className="section">
        <h3>
          <span>{t`Industries Employing`}</span>
        </h3>
        <p>{t`The ${baseEmployment} people currently employed as a ${profile.title} are typically employed across the following industries:`}</p>
        <ResponsiveContainer aspect={3 / 2} width="100%">
          <PieChart width={300} height={200} isAnimationActive={false}>
            <Pie data={cd} dataKey="value">
              {cd?.map((e, index) => (
                <Cell
                  key={`cell${index}`}
                  fill={dynamicValues.plotColors[index % dynamicValues.plotColors.length]}
                />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
        <table className="tbl table">
          <thead>
            <tr>
              <th>{t`Industry`}</th>
              <th>{t`Percentage`}</th>
            </tr>
          </thead>
          <tbody>
            {cd?.map((c, idx) => (
              <tr className={idx % 2 === 0 ? 'even' : 'odd'}>
                <td>
                  {c.naics ? (
                    <Link to={`/industry/detail/${c.naics}`}>{c.name}</Link>
                  ) : (
                    c.name
                  )}
                </td>
                <td>{c.value.toFixed(2)}%</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )
  }
  const workKeys = () => {
    if (!profile.workKeys || !profile.workKeys.skills.length || !dynamicValues.workKeys) {
      return null
    }

    const certificateType = profile.workKeys.crc ? (
      <b>{profile.workKeys.crc.name}</b>
    ) : null

    return (
      <div className="section">
        <h3>
          <span>{t`Work Keys`}</span>
        </h3>
        {profile.workKeys.crc && (
          <p>{jt`This occupation requires a ${certificateType} certificate`}</p>
        )}
        <table className="tbl table">
          <thead>
            <tr>
              <th>{t`Skill`}</th>
              <th>{t`Level`}</th>
            </tr>
          </thead>
          <tbody>
            {profile.workKeys.skills?.map((c, idx) => (
              <tr className={idx % 2 === 0 ? 'even' : 'odd'}>
                <td>{c.name}</td>
                <td>{c.level}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <p className="disclaimer">{t`WorkKeys\u00AE is a registered trademark of ACT, Inc., which was not involved in the production of, and does not endorse, this product.`}</p>
      </div>
    )
  }
  const youAndOcc = () => {
    const per = profile.personalization
    const rating = per && per.hasOwnProperty('rating') ? per.rating : null
    const compNumber =
      per && per?.hasOwnProperty('compatibility') ? per?.compatibility?.score || 0 : 0
    const comp = compNumber => {
      switch (compNumber) {
        case 1:
          return compatibility1
        case 2:
          return compatibility2
        case 3:
          return compatibility3
        case 4:
          return compatibility4
        case 5:
          return compatibility5

        default:
          return compatibility0
      }
    }
    const lastView = new Date(per?.lastView).toLocaleDateString()

    return (
      <div>
        <div className=" youandocc">
          <h3>{t`You and This Occupation`}</h3>
          <div className="row" style={{ marginRight: 0 }}>
            <div className="useractions col-xs-6">
              <div className="itemrating">
                <a href="javascript:void(0)" onClick={() => rateOccupation(profile, 5)}>
                  <img
                    src={rating && rating >= 3 ? like : likeInactive}
                    alt={t`Thumbs Up for Like Occupation Link`}
                  />
                </a>
                <a href="javascript:void(0)" onClick={() => rateOccupation(profile, 1)}>
                  <img
                    src={rating && rating < 3 ? dislike : disllikeInactive}
                    alt={t`Thumbs down for Dislike Occupation Link`}
                  />
                </a>
                {t`Your Rating`}
              </div>
            </div>
            <div className="useractions col-xs-6">
              <div className="itemcompatability">
                <a href={`/occupations/analysis/${profile.onetSoc}`}>
                  <img
                    src={comp(compNumber)}
                    alt={t`Occupation compatibility graph: score ${compNumber} out of 5`}
                  />{' '}
                </a>
                {t`Compatibility`}
              </div>
            </div>

            <div className="col-xs-3 history-item col-xs-offset-3">
              <div className={`personalize-history`}>
                <h4
                  className={
                    ((per && per.employmentHistory) || []).length ? 'hasData' : ''
                  }>
                  {((per && per.employmentHistory) || []).length || 0}
                </h4>
                <span>{t`Resumes`}</span>
                <button
                  onClick={() =>
                    (window.location = `/jobtools/resume/addemployment?type=occupation&onetSoc=${profile.onetSoc}`)}>
                  {t`Add`}
                </button>
              </div>
            </div>
            <div className="col-xs-3 history-item">
              <div className={`personalize-history`}>
                <h4 className={((per && per.journals) || []).length ? 'hasData' : ''}>
                  {((per && per.journals) || []).length || 0}
                </h4>
                <span>{t`Journals`}</span>
                <button onClick={() => openModal('journal', true)}>{t`Add`}</button>
              </div>
            </div>
            <div className="col-xs-3 history-item">
              <div className={`personalize-history`}>
                <h4 className={((per && per.plans) || []).length ? 'hasData' : ''}>
                  {((per && per.plans) || []).length || 0}
                </h4>
                <span>{t`Plans`}</span>
                <button onClick={() => openModal('plan', true)}>{t`Add`}</button>
              </div>
            </div>
          </div>
          {per?.lastView && (
            <div className="lastView">{jt`You last viewed this on ${lastView}`}</div>
          )}
        </div>
      </div>
    )
  }
  const interests = () => {
    const firstInterest =
      profile?.interests?.length > 0 ? <b>{profile?.interests[0]?.name}</b> : 'n/a'
    const secondInterest =
      profile?.interests?.length > 1 ? <b>{profile?.interests[1]?.name}</b> : 'n/a'
    const thirdInterest =
      profile?.interests?.length > 2 ? <b>{profile?.interests[2]?.name}</b> : null
    const twoIntSummary = jt`This means people who work in this occupation generally have ${firstInterest} interests, but also prefer ${secondInterest} environments.`
    const threeIntSummary = jt`This means people who work in this occupation generally have ${firstInterest} interests, but also prefer ${secondInterest} and ${thirdInterest} environments.`
    const code = <b>{profile?.interests?.map(i => i.name.charAt(0)).join('')}</b>

    return (
      <div className="col-sm-6">
        <div className="interest-box callout-box">
          <h3>{t`Interests`}</h3>
          <p>{jt`People who work in this occupation generally have the interest code: ${code}.`}</p>
          <p>{thirdInterest ? threeIntSummary : twoIntSummary} </p>
        </div>
      </div>
    )
  }
  const workValues = () => {
    const firstWorkValue =
      profile?.workValues?.length > 0 ? <b>{profile?.workValues[0]?.name}</b> : 'n/a'
    const secondWorkValue =
      profile?.workValues?.length > 1 ? <b>{profile?.workValues[1]?.name}</b> : 'n/a'
    const thirdWorkValue =
      profile?.workValues?.length > 2 ? <b>{profile?.workValues[2]?.name}</b> : 'n/a'

    return (
      <div className="col-sm-6">
        <div className="workvalue-box callout-box">
          <h3>{t`Work Values`}</h3>
          <p>{jt`People who work in this occupation generally prize ${firstWorkValue}, but also value ${secondWorkValue} and ${thirdWorkValue} in their jobs.`}</p>
        </div>
      </div>
    )
  }
  const outputOnetSection = (sectionKey, title) => {
    return (
      <div className="section">
        <h3>
          <span>{title}</span>
        </h3>
        <ExpandableList
          items={profile[sectionKey]}
          formatter={t => (
            <li key={t.name}>
              <span className="element-name">{t.name}</span> - {t.description}
            </li>
          )}
          numWhenClosed={5}
        />
      </div>
    )
  }
  const firstPic = () => {
    const newImagesPrefix = 'videos/'
    const o = profile?.media
      ?.filter(f => ['PICTURE', 'AWSPICTURE'].includes(f?.mediaType))
      .sort((a, b) => {
        const firstNew = a.fileName.indexOf(newImagesPrefix) === 0
        const secondNew = b.fileName.indexOf(newImagesPrefix) === 0
        const isEqual = firstNew === secondNew

        if (isEqual) {
          return b.fileName.localeCompare(a.fileName)
        }

        if (firstNew) {
          return -1
        }

        return 0
      })

    //console.log(o)
    return o?.length > 0 ? (o[0] || {}).url : occupations
  }

  return (
    <div id="profileinfocontainer">
      <div className="container">
        <div className="">
          <div className="headerBox row">
            <div className="title-section col-sm-5">
              <h3>{profile.title}</h3>
              {profile.cluster && (
                <ul>
                  <li
                    className={`cluster-link cluster-${generateClassName(
                      profile.cluster.id
                    )}`}>
                    <Link to={profile.cluster.url}>
                      {t`A member of ${profile.cluster.name}`}
                    </Link>
                  </li>
                </ul>
              )}
            </div>
            <div className="lmi-callout col-sm-5">
              <LmiBox profile={profile} openRegionsModal={openRegionsModal} />
            </div>
            <div className="col-sm-2 action-container">
              <a
                className="btn no-style media"
                href="javascript:void(0)"
                disabled={!profile.media || profile.media.length === 0}
                onClick={() => openModal('media', false)}>
                <div
                  className="thumb"
                  style={{
                    backgroundImage: `url(${firstPic()})`
                  }}>
                </div>
                <div
                  className="text"
                  style={{
                    display:
                      !profile.media || profile.media.length === 0 ? 'none' : 'block'
                  }}>
                  <i className="fal fa-camera"></i>
                  <div>{t`Media Gallery`}</div>
                </div>
              </a>
              <a
                className="btn no-style share"
                href="javascript:void(0)"
                onClick={() => openModal('share', false)}>
                <span className="sr-only">{t`Share`}</span>
              </a>
              <a className="btn no-style print" href={profile.printUrl}>
                <span className="sr-only">{t`Print`}</span>
              </a>
              {/*<a className="btn" href="javascript:void(0)" onClick={() => onFlagOccupation(profile)}>
                        <i className="fal fa-flag" style={{ color: (profile.personalization && profile.personalization.bookmarked) ? "orange" : "initial" }}></i><span className="sr-only">{t`Bookmark`}</span>
                            </a>   */}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-7 leftcolprofile">
            {aboutSection()}
            {whatTheyDoSection()}
            <div className="row flex">
              {interests()}
              {workValues()}
            </div>
            {outputOnetSection('knowledge', t`Things They Need to Know`)}
            {outputOnetSection('skills', t`Things They Need to Be Able to Do`)}
            <SimilarOccupations
              currentOccupation={profile.onetSoc}
              showMilitary={dynamicValues.includeMilitaryCustomizations}
              relatedOnet={profile.related}
              relatedMilitary={profile.militaryEquivalent}
              occupationMeta={profile.occupationMeta}
              selectedOccupations={selectedOccupations}
              onSelectOccupationForComparison={onSelectOccupationForComparison}
              onRemoveOccupationForComparison={onRemoveOccupationForComparison}
              jobZoneValues={jobZoneValues}
            />
          </div>
          <div className="col-sm-5 rightcol">
            {youAndOcc()}
            {dynamicValues.tenantId === 'nevada' && (
              <div style={{ padding: '15px 0' }}>
                <RecommendationCard
                  recommendation={{
                    name: 'Hot Opportunities in Nevada',
                    description:
                      'Nevada offers many opportunities to help you advance your career',
                    type: 'resilient',
                    recommendedBy: 'none',
                    url: '/opportunities/information/33'
                  }}
                />
              </div>
            )}
            {dynamicValues.versionThreeLocalOpportunities ? (
              <LocalOpportunityTypes
                types={profile?.wblTypes}
                primaryCluster={profile?.cluster?.id ?? null}
              />
            ) : null}
            <LocalOpportunitySection
              profile={profile}
              selectedLocalTab={selectedLocalTab}
              onSelectLocalTab={onSelectLocalTab}
              logJobOrderView={logJobOrderView}
              localOpportunitiesLoading={localOpportunitiesLoading}
            />
            <MobileLmi profile={profile} />
            {industryBreakdown()}
            {workKeys()}
          </div>
        </div>
      </div>
      <ComparisonFooter />
      <Modal bsSize="large" show={selectedModal === 'media'} onHide={closeModal}>
        <Modal.Header closeButton>
          <h2>{t`Media Gallery for ${profile.title}`}</h2>
        </Modal.Header>
        <Modal.Body>
          <MediaSlideshow
            onetSoc={profile.onetSoc}
            dispatch={dispatch}
            media={(profile.media || []).sort((a, b) =>
              a.mediaType === 'VIMEO' ? 0 : 1
            )}
          />
        </Modal.Body>
      </Modal>
      <Modal bsSize="large" show={selectedModal === 'region'} onHide={closeModal}>
        <Modal.Header closeButton>
          <h2>{t`Comparison Region Selector`}</h2>
        </Modal.Header>
        <Modal.Body>
          <ComparisonRegionSelector onSelectRegion={onSelectRegion(profile)} />
        </Modal.Body>
      </Modal>
      <Modal bsSize="large" show={selectedModal === 'plan'} onHide={closeModal}>
        <Modal.Header closeButton>
          <h2>{t`Create Plan`}</h2>
        </Modal.Header>
        <Modal.Body>
          {profile.personalization?.plans && profile.personalization?.plans?.length > 0 && (
            <div>
              <h3>{t`Choose one of your existing plans from the list below`}</h3>
              <ul>
                {profile.personalization?.plans?.map(p => (
                  <li key={p.url}>
                    <a href={p.url}>{p.title}</a>{' '}
                    <span className="small italic">
                      ({t`created:`} {new Date(p.dateCreated).toLocaleDateString()})
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          )}
          <h3>{t`To create a new plan, choose to:`}</h3>
          <div className="actions text-center">
            <button
              style={{ marginRight: '3px' }}
              onClick={() => onCreatePlan(profile.onetSoc, 0)}
              className="btn btn-success">
              {t`Plan for Career Exploration`}
            </button>
            <button
              style={{ marginLeft: '3px' }}
              onClick={() => onCreatePlan(profile.onetSoc, 1)}
              className="btn btn-success">
              {t`Plan for Plan for a Job Application`}
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        bsSize="large"
        enforceFocus={false}
        show={selectedModal === 'journal'}
        onHide={closeModal}>
        <Modal.Header closeButton>
          <h2>{t`Journal Entries`}</h2>
        </Modal.Header>
        <Modal.Body>
          {profile?.personalization?.journals && (
            <PopupJournal
              journals={profile.personalization?.journals}
              objectType={profile.personalization?.journalType}
              objectId={profile?.onetSoc}
              objectTitle={profile?.title}
            />
          )}
        </Modal.Body>
      </Modal>
      <Modal bsSize="large" show={selectedModal === 'share'} onHide={closeModal}>
        <Modal.Header closeButton>
          <h2>{t`Social`}</h2>
        </Modal.Header>
        <Modal.Body>{<Share />}</Modal.Body>
      </Modal>
    </div>
  )
}

export default connect(
  state => {
    return {
      ...state.occupations?.profile,
      profileRequest: state.occupations.profileRequest,
      selectedOccupations: state.occupations.comparison.selectedOccupations,
      jobZoneValues: state.jobZones.jobZoneValues,
      selectedTab: 1
    }
  },
  dispatch => ({
    dispatch,
    rateOccupation: (occupation, rating) => {
      if (dynamicValues.userProfile) {
        dispatch(rateOccupation(occupation, rating))
      } else {
        dispatch(openSigninDialog('signIn'))
      }
    },
    logJobOrderView: (occupation, jobOrder) => {
      dispatch(
        h2Api.post(`/occupations/profile/${occupation.onetSoc}/jobopenings/log`, {
          logString: jobOrder.logString
        })({ type: 'INTERNAL_JOBS_LOG' })
      ).then(v => {
        if (jobOrder.newWindow) {
          window.open(jobOrder.url, '_blank')
        } else {
          window.location.href = jobOrder.url
        }
      })
    },
    onSelectRegion: occupation => region =>
      dispatch(selectComparisonRegion(occupation, region)).then(() =>
        dispatch(toggleOccupationModal(null))
      ),
    onFlagOccupation: occupation => dispatch(flagOccupation(occupation)),
    openRegionsModal: () => {
      dispatch(retrieveComparisonRegions()).then(() =>
        dispatch(toggleOccupationModal('region'))
      )
    },
    onCreatePlan: (occupation, planType) => {
      dispatch(createPlan(occupation, planType)).then(p => {
        window.location.href = p.url
      })
    },
    openModal: (modalName, requireLoggedIn) => {
      if (!!requireLoggedIn && !dynamicValues.userProfile) {
        dispatch(openSigninDialog('signIn'))
      } else {
        dispatch(toggleOccupationModal(modalName))
      }
    },
    closeModal: () => dispatch(toggleOccupationModal(null)),
    onSelectLocalTab: (onetSoc, t) => dispatch(selectLocalTab(onetSoc, t)),
    onSelectOccupationForComparison: (initial, itm) => {
      //console.log(itm)
      dispatch(selectForComparison(initial))
      dispatch(selectForComparison(itm))
    },
    onRemoveOccupationForComparison: itm => dispatch(removeForComparison(itm))
  })
)(withRecharts(OccupationProfile))
